import { Component, Input, OnInit, AfterViewInit } from '@angular/core';
import { FormControl, FormGroup } from '@angular/forms';
import { Step2 } from '../../../../shared/models/component-messages/mapaAN/step2';
import { TypeDescMarche } from '../models/TypeDescMarche';
import { TypeLieu } from '../models/TypeLieu';
import { CTRL_268 } from '../../../validators/268/ctrl268';
import { AvisDataTransferService } from '../../../../shared/services/avis-data-transfer.service';
@Component({
  selector: 'app-type-desc-marche',
  templateUrl: './type-desc-marche.component.html'
})
export class TypeDescMarcheComponent implements OnInit, AfterViewInit {

  @Input() uid = '';
  public current_uid = 'TypeDescMarche'
  @Input() parentForm: FormGroup;
  @Input() description : TypeDescMarche;
  @Input() disabled : boolean;
  estCbChecked: boolean;

  public step2 = new Step2();
  public rg2 = CTRL_268.id + '_2';
  public rg3 = CTRL_268.id + '_3';
  public rg4 = CTRL_268.id + '_4';

  constructor(private avisDataTransferService: AvisDataTransferService) { }

  public ngOnInit() {
    this.isChecked();
  }

  ngAfterViewInit() {
    this.researchFormOnChangeDetecte();
  }

  researchFormOnChangeDetecte(){
    const controlName = this.getUid() + '_SepAtt_lieuExecutionLivraisonCB';
    const control = this.parentForm.get(controlName);
    if (control) {
      control.valueChanges.subscribe(value => {
        this.isChecked()
      });
    }
  }

  getUid() {
    return this.uid + '_SepSep_' + this.current_uid;
  }

  isChecked() {
    this.estCbChecked = this.parentForm.controls[this.getUid() + '_SepAtt_lieuExecutionLivraisonCB'] ?
                        this.parentForm.controls[this.getUid() + '_SepAtt_lieuExecutionLivraisonCB'].value :
                        this.avisDataTransferService.getFormData().jsonSaisieFormulaire.ann.mapa.annulationFromMAPA.description.isLieuExecutionLivraison;
    if(this.estCbChecked) {
      if(this.description.lieuExecutionLivraison == null) this.description.lieuExecutionLivraison = new TypeLieu();
      this.description.lieuExecution = null;
      this.description.lieuLivraison = null;
      this.parentForm.addControl(this.getStepId() + this.rg2, new FormControl({ rgCtrls: this.getCtrl_268_1Names_json() }));
    } else {
      this.description.lieuExecutionLivraison = null;
      if(this.description.lieuExecution == null) this.description.lieuExecution = new TypeLieu();
      if(this.description.lieuLivraison == null) this.description.lieuLivraison = new TypeLieu();
      this.parentForm.addControl(this.getStepId() + this.rg3, new FormControl({ rgCtrls: this.getCtrl_268_2Names_json() }));
      this.parentForm.addControl(this.getStepId() + this.rg4, new FormControl({ rgCtrls: this.getCtrl_268_3Names_json() }));
    }
  }

  getStepId() {
    return this.uid.substring(0, this.uid.indexOf("SepSep"));
  }
  _SepSep_Annulation_SepSep_TypeDescMarche_lieuExecution_SepSep_TypeLieu_SepAtt_cp
  _SepSep_Annulation_SepSep_TypeDescMarche_lieuLivraison_SepSep_TypeLieu_SepAtt_cp

  private getCtrl_268_1Names_json(): any {
    const deptPub = '_SepSep_TypeIndexation_SepSep_TypeDept_SepAtt_deptPub';
    const cp = '_SepSep_Annulation_SepSep_TypeDescMarche_lieuExecutionLivraison_SepSep_TypeLieu_SepAtt_cp';
    return { firstChamp: deptPub, secondChamp: cp };
  }

  private getCtrl_268_2Names_json(): any {
    const deptPub = '_SepSep_TypeIndexation_SepSep_TypeDept_SepAtt_deptPub';
    const cp = '_SepSep_Annulation_SepSep_TypeDescMarche_lieuExecution_SepSep_TypeLieu_SepAtt_cp';
    return { firstChamp: deptPub, secondChamp: cp };
  }

  private getCtrl_268_3Names_json(): any {
    const deptPub = '_SepSep_TypeIndexation_SepSep_TypeDept_SepAtt_deptPub';
    const cp = '_SepSep_Annulation_SepSep_TypeDescMarche_lieuLivraison_SepSep_TypeLieu_SepAtt_cp';
    return { firstChamp: deptPub, secondChamp: cp };
  }
}

